import React from 'react';
// Images
import BrunchOutline from '../../assets/images/backgrounds/brunch-outline-white.png';

const BrunchComponent = () => {
  return (
    <section
      id='brunch'
      className='grid w-full bg-colour1 text-white border-b-2 border-t-2 border-solid border-colour2'
    >
      <div className='grid w-full px-6 py-20 lg:py-10 lg:min-h-[80vh]'>
        {/* Mobile */}
        <section className='grid lg:hidden text-center'>
          <div className='grid'>
            <h3 className='font-GaramondBold text-4xl md:text-5xl font-bold'>
              Weekend Brunch
            </h3>
          </div>

          <div className='grid pt-6'>
            <p className='text-lg md:text-xl leading-relaxed'>
              Join us for a relaxed weekend brunch at The Tavistock Inn.
              Traditional favourites served in a warm pub atmosphere.
            </p>
          </div>

          <div className='grid pt-6'>
            <p className='text-text-colour font-semibold text-xl'>
              08:00 – 11:00 · Saturday & Sunday
            </p>
          </div>

          <div className='grid pt-2'>
            <p className='text-text-colour font-semibold text-xl'>
              £8.95 per person
            </p>
          </div>

          <div className='grid pt-8'>
            <img src={BrunchOutline} alt='' className='max-w-56 mx-auto' loading='lazy' />
          </div>
        </section>

        {/* Desktop */}
        <section className='hidden lg:grid grid-cols-[1fr_0.6fr] w-full h-full'>
          {/* Left: Article */}
          <section className='grid relative justify-center items-center border-r-2 border-solid border-colour2'>
            <div className='grid w-3/4 mx-auto z-10'>
              <div className='grid'>
                <h3 className='text-6xl font-GaramondBold font-bold'>
                  Weekend Brunch
                </h3>
              </div>

              <div className='grid pt-6'>
                <p className='text-xl leading-relaxed'>
                  Start your weekend the right way with brunch at The Tavistock
                  Inn. A relaxed morning menu served in our traditional pub
                  setting.
                </p>
              </div>

              <div className='grid pt-6'>
                <p className='text-text-colour font-semibold text-xl'>
                  08:00 – 11:00 · Saturday & Sunday
                </p>
              </div>

              <div className='grid pt-2'>
                <p className='text-text-colour font-semibold text-xl'>
                  £8.95 per person (inclusive for residents)
                </p>
              </div>
            </div>
          </section>

          {/* Right: Outline only */}
          <section className='grid relative items-center justify-center'>
            <img src={BrunchOutline} alt='' className='w-80 xl:w-[420px]' loading='lazy' />
          </section>
        </section>
      </div>
    </section>
  );
};

export default BrunchComponent;
